import { cn } from '@/lib/utils';
import { useContext, useEffect, useState } from 'react';

import { ChainlitContext, useConfig } from '@chainlit/react-client';

interface Props {
  className?: string;
}

export const UserLogo = ({ className }: Props) => {
  const { config } = useConfig();
  const apiClient = useContext(ChainlitContext);
  const [logo_url, setlogo_url] = useState<string>();

  async function setUserLogo() {
    var userLogo = await apiClient.getUserLogo()
    setlogo_url(userLogo)
  }

  useEffect(() => {
    setUserLogo()
  }, []);

  return (
    <img
      src={logo_url}
      className={cn('customer_logo', className)}
      style={{
          maxHeight: '30px',
      }}
    />
  );
};
